export default {
  'SET_ROOMS'(state, data) {
    state.rooms = data;
  },
  'SET_FLOORS'(state, data) {
    state.floors = data;
  }
};